<template>
    <ExtendedLayout
        :user="user"
        currentTab="vacations"
    >

        <InertiaLink :href="$route('admin::users.vacations.create', { user: user.id })" class="inline-block bg-white shadow rounded-lg py-4 px-8 hover:bg-gray-100 transition-all font-bold">
            {{ __('admin::general.create_model', {'model': __('admin::vacations.vacation').toLowerCase() }) }}
        </InertiaLink>

        <Table
            :headings="[
                __('admin::labels.period'),
                __('admin::labels.state'),
                __('admin::labels.deputy_user'),
                __('admin::labels.texts'),
                __('admin::labels.vacation_notice'),
                __('admin::labels.comment'),
                __('admin::labels.salary'),
            ]"
            :paginator="paginator"
            :withFilters="false"
        >

            <template #results>
                <tr v-for="vacation in paginator.data" :key="vacation.id">
                    <td>{{ $date(vacation.starts_at) }} - {{ $date(vacation.ends_at) }}</td>
                    <td>
                        <span
                            class="inline-block py-1 px-2 text-sm rounded-md"
                            :class="{
                                'bg-purple-200 text-purple-700': vacation.state === 'request',
                                'bg-blue-200 text-blue-700': vacation.state === 'upcoming',
                                'bg-yellow-200 text-yellow-700': vacation.state === 'current',
                                'bg-gray-200 text-gray-700': vacation.state === 'old',
                            }"
                        >
                            <span v-if="vacation.state === 'request'">{{ __('admin::vacations.state_request') }}</span>
                            <span v-if="vacation.state === 'upcoming'">{{ __('admin::vacations.state_upcoming') }}</span>
                            <span v-if="vacation.state === 'current'">{{ __('admin::vacations.state_current') }}</span>
                            <span v-if="vacation.state === 'old'">{{ __('admin::vacations.state_old') }}</span>
                        </span>
                    </td>
                    <td>{{ vacation.deputy_user?.name || '—' }}</td>
                    <td>{{ vacation.use_default_messages ? __('admin::labels.default_messages') : __('admin::labels.custom_messages') }}</td>
                    <td>{{ vacation.days_to_show_notice_before_start }} {{ __('admin::labels.days_before').toLowerCase() }}</td>
                    <td>{{ vacation.comment || '—' }}</td>
                    <td>
                        <CheckIcon class="w-4 h-4 text-green-500" v-if="vacation.synced_with_salary" />
                        <XIcon class="w-4 h-4 text-red-500" v-else />
                    </td>
                    <td>
                        <TableButton
                            variant="edit"
                            :href="$route('admin::users.vacations.edit', { user: user.id, vacation: vacation.id })"
                        />
                        <TableButton
                            variant="destroy"
                            @delete="deleting = $route('admin::users.vacations.destroy', { user: user.id, vacation: vacation.id })"
                        />
                    </td>
                </tr>
            </template>

        </Table>

        <DeleteDialog
            :title="__('admin::general.delete_model', { model: __('admin::vacations.vacation') })"
            :url="deleting"
            v-if="deleting"
            @closed="deleting = null"
        />

    </ExtendedLayout>
</template>

<script>
import ExtendedLayout from '@A/Pages/Users/Edit';
import {CheckIcon, XIcon} from "@heroicons/vue/solid";

export default {
    components: {
        ExtendedLayout,
        CheckIcon,
        XIcon,
    },
    props: {
        errors: Object,
        user: Object,
        paginator: Object,
    },
    data() {
        return {
            deleting: null,
        }
    },
}
</script>
